import { createSelector } from 'reselect';

const selectAccountTransactions = (state: any) => state.accountTransactions;


export const selectAccountTransactionsCurrentItem = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.current);

export const selectAccountTransactionsListItems = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.list);

export const selectAccountTransactionsItemById = (itemId: any) =>
    createSelector(selectAccountTransactionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountTransactionsCreatedItem = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.create);

export const selectAccountTransactionsUpdatedItem = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.update);

export const selectAccountTransactionsReadItem = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.read);

export const selectAccountTransactionsDeletedItem = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.delete);

export const selectAccountTransactionsearchedItems = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.search);

export const selectAccountTransactionsItemsCount = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.count);

export const selectAccountTransactionsItemsFilter = createSelector([selectAccountTransactions], (accountTransactions) => accountTransactions.filter);